import { useParams } from "react-router-dom";
import { t } from "../constants/i18n";
import { useRemoteProjects } from "../hooks/useRemoteData";
import ProjectPage from "./ProjectPage";
import type { Lang } from "../constants/i18n";

interface ProjectDetailProps {
  lang: Lang;
}

export default function ProjectDetail({ lang }: ProjectDetailProps) {
  const { slug } = useParams<{ slug: string }>();
  const { data: PROJECTS, loading } = useRemoteProjects();
  const entry = PROJECTS.find((p) => p.slug === slug);

  if (!entry) {
    return (
      <div className="pp">
        <div className="pp-hero">
          <div className="container">
            <p className="pp-not-found">{loading ? "loading..." : "project not found."}</p>
          </div>
        </div>
      </div>
    );
  }

  return <ProjectPage lang={lang} entry={entry} backTo="/projects" backLabel={t(lang, "nav_projects")} />;
}
